const mvSwiper = new Swiper('.mv-swiper', {
  // Optional parameters
  loop: true, // ループ
  speed: 1000, // 少しゆっくり(デフォルトは300)
  slidesPerView: 1.25, // 一度に表示する枚数
  spaceBetween: 2, // スライド間の距離
  centeredSlides: true, // アクティブなスライドを中央にする
  autoplay: {
    // 自動再生
    delay: 3000, // x000=x秒後に次のスライド
    disableOnInteraction: false, // 矢印をクリックしても自動再生を止めない
  },

  // ページネーション
  pagination: {
    el: '.swiper-pagination',
    clickable: true,
  },

  // Navigation arrows
  navigation: {
    nextEl: '.swiper-button-next',
    prevEl: '.swiper-button-prev',
  },
  breakpoints: {
    // ブレークポイント
    750: {
      // 画面幅750px以上で適用
      slidesPerView: 1.25, // 一度に表示する枚数
      spaceBetween: 2, // スライド間の距離
      centeredSlides: true, // アクティブなスライドを中央にする
      pagination: {
        el: '.swiper-pagination',
        clickable: true,
      },
    },
  },
})
